import styled from 'styled-components'
import Link from '../../utils/Link'

export default styled(Link)`
  color: #333;
  font-size: 13px;
`
